module.exports = __webpack_public_path__ + "static/media/photo-12.d87c0541.png";